import { render, staticRenderFns } from "./popComponent.vue?vue&type=template&id=5f6fab60&scoped=true"
import script from "./popComponent.vue?vue&type=script&lang=js"
export * from "./popComponent.vue?vue&type=script&lang=js"
import style0 from "./popComponent.vue?vue&type=style&index=0&id=5f6fab60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6fab60",
  null
  
)

export default component.exports